"use client";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import ICON_ARROW_DOWN_MATCHES from "@/public/arrow_down_matches.svg";
import ICON_ARROW_UP_MATCHES from "@/public/arrow_up_matches.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_leagues.svg";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_leagues.svg";
import STAR_MATCHES from "@/public/Star_matches.svg";
import STAR_MATCHES_FAVORITED from "@/public/Star_matches_favorited.svg";
import STAR_LEAGUES from "@/public/Star_leagues.svg";
import STAR_LEAGUES_FAVORITED from "@/public/Star_leagues_favorited.svg";
import FLAG_FINISH_DUOTONE_FILL from "@/public/flag_finish_duotone_fill.svg";
import "./index.scss";
import { ADD_FAVORITE_MATCH, REMOVE_FAVORITE_MATCH } from "@/lib/redux/reducers/actionTypes";
// import momenttz from 'moment-timezone';
import { Image } from '@/lib/target';
import {Tooltip} from "@nextui-org/react";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const IMAGE_MATCH_DEFAULT = STAR_MATCHES;
const IMAGE_MATCH_FAVORITED = STAR_MATCHES_FAVORITED;
const IMAGE_ARROW_DOWN_MATCHES = ICON_ARROW_DOWN_MATCHES;
const IMAGE_ARROW_UP_MATCHES = ICON_ARROW_UP_MATCHES;
const IMAGE_LEAGUE_DEFAULT = STAR_LEAGUES;
const IMAGE_LEAGUE_FAVORITED = STAR_LEAGUES_FAVORITED;
const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;


const H2HItem = ({ match }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  let [imageMatchSrc, setImageMatchSrc] = useState(IMAGE_MATCH_DEFAULT);
  let [imageLeagueSrc, setImageLeagueSrc] = useState(IMAGE_LEAGUE_DEFAULT);
  let favoriteMatches = useSelector((state) => state.favoriteReducer.favoriteMatches);
  favoriteMatches = favoriteMatches.map(match => match.id);
  const dispatch = useDispatch();
  
  const handleClickMatchFavorite = (event, match) => {
    event.preventDefault();
    setImageMatchSrc(prevSrc => prevSrc === IMAGE_MATCH_DEFAULT ? IMAGE_MATCH_FAVORITED : IMAGE_MATCH_DEFAULT);
    setImageLeagueSrc(prevSrc => prevSrc === IMAGE_LEAGUE_DEFAULT ? IMAGE_LEAGUE_FAVORITED : IMAGE_LEAGUE_DEFAULT);
    if (imageMatchSrc === IMAGE_MATCH_DEFAULT || imageLeagueSrc === IMAGE_LEAGUE_DEFAULT) {
      dispatch({ type: ADD_FAVORITE_MATCH, payload: match });
    } else {
      dispatch({ type: REMOVE_FAVORITE_MATCH, payload: match });
    }
  }
  return (
    <div className="bangkeo-all-league-fixture mb-1">
      <div className="overflow-x-auto">
        <div className={`block @md:flex bg-header-blue dark:bg-league-dark py-1 items-center justify-between rounded-t-lg w-full gap-x-0 mt-1 ${!isCollapsed ? "rounded-b-lg" : " "}`}>
          <div className="flex flex-wrap items-center justify-between gap-0">
            <div className="flex flex-wrap gap-0 ml-3">
              <div className="flex gap-0">
                <div className="flex flex-col w-[1.5rem] py-1">
                  <div className="flex-1 flex items-center justify-center gap-2">
                  {/* <Image src={imageCollapseMatchSrc} onClick={(event) => handleClickMatchCollapse(event)} className="block dark:hidden hover:cursor-pointer" /> */}
                    {/* <Image src={imageCollapseLeagueSrc} onClick={(event) => handleClickMatchCollapse(event)} className="hidden dark:block hover:cursor-pointer" /> */}
                    <Image src={favoriteMatches?.includes(match.id) ? imageMatchSrc = IMAGE_MATCH_FAVORITED : imageMatchSrc = IMAGE_MATCH_DEFAULT} className="block dark:hidden w-4 h-4" onClick={(event) => handleClickMatchFavorite(event, match)} />
                    <Image src={favoriteMatches?.includes(match.id) ? imageMatchSrc = IMAGE_LEAGUE_FAVORITED : imageMatchSrc = IMAGE_LEAGUE_DEFAULT} className="hidden dark:block w-4 h-4" onClick={(event) => handleClickMatchFavorite(event, match)} />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-0 mx-0 @xl:mx-3">
              <div className="flex gap-0">
                <div className="flex flex-col w-[2rem] @md:w-[4rem] py-1 mx-1">
                  <div className="flex-1 flex items-center justify-center dark:text-stroke-o3 text-[0.75rem]">
                    <span className="font-bold">{dayjs.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("HH:mm")}</span>
                  </div>
                  <div className="flex-1 flex items-center justify-center dark:text-stroke-o3 gap-1">
                    <span className="text-xxs w-10 @md:w-auto text-ellipsis overflow-hidden whitespace-nowrap">{dayjs.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("DD-MM-YYYY")}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-0 mr-0 @xl:mr-3">
              <div className="flex gap-0">
                <div className="flex flex-col w-[2rem] @md:w-12 py-1 mt-1">
                  <div className="flex-1 flex items-center justify-center mb-1 mr-0 @md:mr-3">
                    {/* <span><Image alt="Net88" src={`${match.leagueData?.logo || }`} width={24} height={24}/></span> */}
                        {match.leagueData !== undefined ? <Image alt="Net88" src={`${match.leagueData?.logo}`} width={24} height={24}/> : <Image alt="Net88" src={`https://demofree.sirv.com/nope-not-here.jpg`} width={24} height={24}/>}
                  </div>
                </div>
              </div>
              <div className="flex gap-0">
                <div className="flex flex-col w-12 py-1 mt-1">
                  <div className="flex-1 flex items-center justify-center text-blur-gray dark:text-stroke-o3 text-[0.625rem] mb-1 mr-0 @md:mr-3">
                    <span>{match.league}</span>
                  </div>
                </div>
              </div>
              {/* <div className="flex gap-0">
                <div className="flex flex-col w-[1.5rem] py-1 mt-1">
                  <div className="flex-1 flex items-center justify-center text-blur-gray text-[0.625rem] mb-1">
                    <span>{match.homeRank}</span>
                  </div>
                  <div className="flex-1 flex items-center justify-center text-blur-gray text-[0.625rem] mb-1">
                    <span>{match.awayRank}</span>
                  </div>
                </div>
              </div> */}
              <div className="flex gap-0">
                <div className="flex flex-col @md:w-56 py-1">
                  <div className="flex-1 flex items-center dark:text-stroke-o3 text-[0.75rem]">
                    <span className="font-base w-10 @md:w-auto text-ellipsis overflow-hidden whitespace-nowrap">{match.home}</span>
                  </div>
                  <div className="flex-1 flex items-center dark:text-stroke-o3 text-[0.75rem]">
                    <span className="font-base w-10 @md:w-auto text-ellipsis overflow-hidden whitespace-nowrap">{match.away}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-0  mr-0 @xl:mr-3">
              <div className="flex gap-0">
                <div className="flex flex-col w-[1rem] py-1 mx-1">
                  <div className="flex-1 flex items-center justify-center text-blur-gray dark:text-stroke-o3 text-[0.625rem] mb-1">
                    <span>{match.homeHalfScore}</span>
                  </div>
                  <div className="flex-1 flex items-center justify-center text-blur-gray dark:text-stroke-o3 text-[0.625rem] mt-1">
                    <span>{match.awayHalfScore}</span>
                  </div>
                </div>
              </div>
              <div className="flex gap-0">
                <div className="flex flex-col w-[1rem] py-1">
                  <div className="flex-1 flex items-center justify-center text-[0.625rem] mb-1">
                    <span className="bg-dark-gray dark:bg-large-blue text-white dark:text-stroke-o3 p-1 w-[1rem] h-[1rem] flex items-center justify-center rounded-full border-[0.063rem] border-sm-dark-gray">{match.scoreHome}</span>
                  </div>
                  <div className="flex-1 flex items-center justify-center text-[0.625rem] mt-1">
                  <span className="bg-dark-gray dark:bg-large-blue text-white dark:text-stroke-o3 p-1 w-[1rem] h-[1rem] flex items-center justify-center rounded-full border-[0.063rem] border-sm-dark-gray">{match.scoreAway}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-0  mr-1 @xl:mr-3">
              <div className="flex flex-col w-[2rem] px-1">
                <div className="flex items-start justify-between dark:text-league-dark-detail text-[0.625rem] mb-1 mx-0">
                  {/* <span className="inline-block rounded-sm w-2.5 h-4 bg-yellow-500 text-center">{0}</span> */}
                  <span className="inline-block rounded-sm w-2.5 h-4 bg-red-500 text-white-half text-center">
                    <Tooltip showArrow={true} content="Thẻ Đỏ" className="bg-sm-dark-gray rounded px-2">
                      {match.homeRed}
                    </Tooltip>
                  </span>
                </div>
                <div className="flex items-start justify-between dark:text-league-dark-detail text-[0.625rem] mt-1 mx-0">
                  {/* <span className="inline-block rounded-sm w-2.5 h-4 bg-yellow-500 text-center">{0}</span> */}
                  <span className="inline-block rounded-sm w-2.5 h-4 bg-red-500 text-white-half text-center">
                    <Tooltip showArrow={true} content="Thẻ Đỏ" className="bg-sm-dark-gray rounded px-2">
                      {match.awayRed}
                    </Tooltip>
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-0">
              <div className="flex gap-0">
                <div className="flex flex-col w-[1.5rem] py-1">
                  <div class="flex-1 flex items-center justify-center gap-2">
                    <Image src={FLAG_FINISH_DUOTONE_FILL} />
                  </div>
                </div>
              </div>
              <div className="flex gap-0">
                <div className="flex flex-col w-[0.875rem] py-1 mr-1">
                  <div className="flex-1 flex items-center justify-center dark:text-league-dark-detail text-[0.625rem] mb-1">
                    <span>{match.homeCorner}</span>
                  </div>
                  <div className="flex-1 flex items-center justify-center dark:text-league-dark-detail text-[0.625rem] mt-1">
                    <span>{match.awayCorner}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden @md:block @lg:block @xl:block">
              {/* <div className="flex items-center justify-center gap-2 hover:cursor-pointer mr-2" onClick={handleClickPhanTich}>
                <Image src={thongtin} />
                <span className="text-medium-blue">
                  Chi tiết
                </span>
                <Image src={phantich} />
                <span className="text-medium-blue">
                  Phân tích
                </span>
                <Image src={DECENT} />
                <span className="text-medium-blue">
                  So sánh kèo
                </span>
              </div> */}
            </div>
        </div>
      </div>
    </div>
  );
};

export default H2HItem;
